import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

var _lineSpacings;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import PropTypes from 'prop-types';
import { px, variant } from 'styled-system';
import { createMaxMediaQuery, em } from '../utils';
import { scaledVariant } from '../scales'; // https://quip-apple.com/TMjvAliuX0fh

export var responsiveASC = {
  // phones, phablets, split-screen tablets
  sm: {
    minWidth: 320,
    maxWidth: 735,
    contentWidth: '100%',
    paddingX: 16
  },
  // medium browsers, medium tablets
  md: {
    minWidth: 736,
    maxWidth: 1068,
    contentWidth: '100%',
    paddingX: 20
  },
  // large browsers, large tablets
  lg: {
    minWidth: 1069,
    maxWidth: 1441,
    contentWidth: '100%',
    paddingX: 40
  },
  // xl browsers
  xl: {
    minWidth: 1442,
    maxWidth: 2560,
    contentWidth: 1442,
    paddingX: 40
  }
};
export var breakpoints = ['sm', 'md', 'lg', 'xl'].map(function (bpKey) {
  return responsiveASC[bpKey].maxWidth;
}); // unlike with other theme scale arrays, aliases MUST be provided for each breakpoint

breakpoints.sm = breakpoints[0];
breakpoints.md = breakpoints[1];
breakpoints.lg = breakpoints[2];
breakpoints.xl = breakpoints[3];
var mediaQueries = breakpoints.map(createMaxMediaQuery);

var _mediaQueries = _slicedToArray(mediaQueries, 4);

mediaQueries.sm = _mediaQueries[0];
mediaQueries.md = _mediaQueries[1];
mediaQueries.lg = _mediaQueries[2];
mediaQueries.xl = _mediaQueries[3];
export var maxContentWidth = 920; // px

export var space = [0, 5, 10, 15, 20, 25, 30, 40, 70];
space.spacer0 = space[0];
space.spacer5 = space[1];
space.spacer10 = space[2];
space.spacer15 = space[3];
space.spacer20 = space[4];
space.spacer25 = space[5];
space.spacer30 = space[6];
space.spacer40 = space[7];
space.spacer70 = space[8]; // other spacing aliases

space.tight = space[1];
space.standardSmBp = space[3];
space.standard = space[4];
space.list = space[4];
space.disassociate = space[5];
space.unrelated = space[7];
space.header = space[7];
space.footer = space[8];
export var SCHEME_LIGHT = 'LIGHT';
export var SCHEME_DARK = 'DARK';
export var CONTRAST_MORE = 'MORE';
export var CONTRAST_NORMAL = 'NORMAL';
export var baseColors = {
  // light
  bgLight: '#FFFFFF',
  bgPlaceholderLight: '#FAFAFA',
  ctrlLight: '#0070C9',
  ctrlBgLight: '#F2F2F2',
  ctrlDisabledLight: '#CCCCCC',
  ctrlDisabledLabelLight: '#B2D4EE',
  ctrlHoverLight: '#0064B4',
  footerBgLight: '#F2F2F2',
  keylineLight: '#D6D6D6',
  labelLight: '#333',
  labelCaptionLight: '#666',
  labelPlaceholderLight: '#888',
  labelLegalLight: '#CCCCCC',
  navBgLight: 'rgba(240,240,240,0.8)',
  navLabelLight: '#000',
  navLabelDisabledLight: '#888',
  navLabelHoverLight: '#333',
  navLabelSelectedLight: '#000000',
  titleLight: '#111111',
  badInputBdrLight: '#DE071C',
  badInputBgLight: '#DE071C',
  badInputLabelLight: '#FFFFFF',
  errorLight: '#DE071C',
  errorBdrLight: '#F8CDD2',
  errorBgLight: '#FDECED',
  errorHoverLight: '#C70619',
  infoLight: '#0070C9',
  infoBdrLight: '#CCE2F4',
  infoBgLight: '#EBF4FB',
  infoHoverLight: '#0064B4',
  successLight: '#007D1B',
  successBdrLight: '#CCE5D1',
  successBgLight: '#EBF5ED',
  successHoverLight: '#007018',
  warningLight: '#FFCC00',
  warningBdrLight: '#FFF5CC',
  warningBgLight: '#FFFBEB',
  warningHoverLight: '#E5B700',
  clrBlueLight: '#0070C9',
  clrGreenLight: '#34C759',
  clrOrangeLight: '#FF9500',
  clrPurpleLight: '#AF51DE',
  clrTealLight: '#5CC8FA',
  clrGrayLight: '#8E8E93',
  clrIndigoLight: '#5A55D5',
  clrPinkLight: '#FF46BB',
  clrRedLight: '#FF3C2F',
  clrYellowLight: '#FFCC02',
  // high contrast light
  bgHCLight: '#FFFFFF',
  bgPlaceholderHCLight: '#FAFAFA',
  ctrlHCLight: '#00579E',
  ctrlBgHCLight: '#F2F2F2',
  ctrlDisabledHCLight: '#CCC',
  ctrlDisabledLabelHCLight: '#B2D4EE',
  ctrlHoverHCLight: '#004C8A',
  footerBgHCLight: '#F2F2F2',
  keylineHCLight: '#595959',
  labelHCLight: '#111',
  labelCaptionHCLight: '#333',
  labelPlaceholderHCLight: '#595959',
  labelLegalHCLight: '#CCCCCC',
  navBgHCLight: 'rgba(240,240,240,0.8)',
  navLabelHCLight: '#000',
  navLabelDisabledHCLight: '#888',
  navLabelHoverHCLight: '#333',
  navLabelSelectedHCLight: '#000000',
  titleHCLight: '#000',
  badInputBdrHCLight: '#B30012',
  badInputBgHCLight: '#B30012',
  badInputLabelHCLight: '#FFFFFF',
  errorHCLight: '#B30012',
  errorBdrHCLight: '#99000F',
  errorBgHCLight: '#FDECED',
  errorHoverHCLight: '#99000F',
  infoHCLight: '#00579E',
  infoBdrHCLight: '#004F8F',
  infoBgHCLight: '#EBF4FB',
  infoHoverHCLight: '#004F8F',
  successHCLight: '#006616',
  successBdrHCLight: '#004D11',
  successBgHCLight: '#EBF5ED',
  successHoverHCLight: '#004D11',
  warningHCLight: '#7A6200',
  warningBdrHCLight: '#614E00',
  warningBgHCLight: '#FFFBEB',
  warningHoverHCLight: '#614E00',
  clrBlueHCLight: '#0070C9',
  clrGreenHCLight: '#23863B',
  clrOrangeHCLight: '#AD6500',
  clrPurpleHCLight: '#AA47DC',
  clrTealHCLight: '#037FB0',
  clrGrayHCLight: '#75757A',
  clrIndigoHCLight: '#5A55D5',
  clrPinkHCLight: '#E0008E',
  clrRedHCLight: '#EB1000',
  clrYellowHCLight: '#8F7200',
  // dark
  bgDark: '#1E1E1E',
  bgPlaceholderDark: '#252525',
  ctrlDark: '#3897FE',
  ctrlBgDark: '#2B2B2B',
  ctrlDisabledDark: '#575757',
  ctrlDisabledLabelDark: '#254160',
  ctrlHoverDark: '#5FABFE',
  footerBgDark: '#252525',
  keylineDark: '#3F3F3F',
  labelDark: '#DDDDDD',
  labelCaptionDark: '#888',
  labelPlaceholderDark: '#7D7D7D',
  labelLegalDark: '#454545',
  navBgDark: '#2B2B2B',
  navLabelDark: '#DDDDDD',
  navLabelDisabledDark: '#575757',
  navLabelHoverDark: '#FFFFFF',
  navLabelSelectedDark: '#E8E8E8',
  titleDark: '#E8E8E8',
  badInputBdrDark: '#FF3333',
  badInputBgDark: '#FF3333',
  badInputLabelDark: '#FFFFFF',
  errorDark: '#FF3333',
  errorBdrDark: '#4B2222',
  errorBgDark: '#3F1F1F',
  errorHoverDark: '#FF4747',
  infoDark: '#3897FE',
  infoBdrDark: '#23364B',
  infoBgDark: '#202933',
  infoHoverDark: '#5FABFE',
  successDark: '#007D1B',
  successBdrDark: '#223718',
  successBgDark: '#1F291A',
  successHoverDark: '#1A8A32',
  warningDark: '#FFD60A',
  warningBdrDark: '#4B431A',
  warningBgDark: '#342F1B',
  warningHoverDark: '#FFDA22',
  clrBlueDark: '#1184FF',
  clrGreenDark: '#31D158',
  clrOrangeDark: '#FF9F0A',
  clrPurpleDark: '#BF5AF2',
  clrTealDark: '#64D1FF',
  clrGrayDark: '#98989D',
  clrIndigoDark: '#5E5BE6',
  clrPinkDark: '#FF46BB',
  clrRedDark: '#FF453A',
  clrYellowDark: '#FFD60A',
  // high contrast dark
  bgHCDark: '#1E1E1E',
  bgPlaceholderHCDark: '#252525',
  ctrlHCDark: '#71B5FE',
  ctrlBgHCDark: '#2B2B2B',
  ctrlDisabledHCDark: '#575757',
  ctrlDisabledLabelHCDark: '#254160',
  ctrlHoverHCDark: '#5FABFE',
  footerBgHCDark: '#252525',
  keylineHCDark: '#BCBCBC',
  labelHCDark: '#FFFFFF',
  labelCaptionHCDark: '#BBBBBB',
  labelPlaceholderHCDark: '#A3A3A3',
  labelLegalHCDark: '#454545',
  navBgHCDark: '#2B2B2B',
  navLabelHCDark: '#DDDDDD',
  navLabelDisabledHCDark: '#575757',
  navLabelHoverHCDark: '#FFFFFF',
  navLabelSelectedHCDark: '#E8E8E8',
  titleHCDark: '#FFFFFF',
  badInputBdrHCDark: '#FF8585',
  badInputBgHCDark: '#FF8585',
  badInputLabelHCDark: '#FFFFFF',
  errorHCDark: '#FF8585',
  errorBdrHCDark: '#FF8585',
  errorBgHCDark: '#311818',
  errorHoverHCDark: '#FF4747',
  infoHCDark: '#61ADFE',
  infoBdrHCDark: '#61ADFE',
  infoBgHCDark: '#181E26',
  infoHoverHCDark: '#99CAFF',
  successHCDark: '#00C62B',
  successBdrHCDark: '#00C62B',
  successBgHCDark: '#1A2216',
  successHoverHCDark: '#21DC4A',
  warningHCDark: '#FFD60A',
  warningBdrHCDark: '#FFD60A',
  warningBgHCDark: '#342F1B',
  warningHoverHCDark: '#FFDA22',
  clrBlueHCDark: '#3295FF',
  clrGreenHCDark: '#31D158',
  clrOrangeHCDark: '#FF9F0A',
  clrPurpleHCDark: '#C76DF4',
  clrTealHCDark: '#64D1FF',
  clrGrayHCDark: '#98989D',
  clrIndigoHCDark: '#8483EC',
  clrPinkHCDark: '#FF46BB',
  clrRedHCDark: '#FF473E',
  clrYellowHCDark: '#FFD60A',
  // ye olde
  focus: 'rgba(131,192,253,0.5)',
  podcastPurple: '#7D50DF',
  tvBlue: '#00BFF1',
  tvBlueHighContrast: '#007FB1',
  appleMusicRedLight: '#D60017',
  appleMusicRedDark: '#FA2D48'
}; // fill theme slots

export var colors = _objectSpread(_objectSpread({
  SCHEME: SCHEME_LIGHT,
  CONTRAST: CONTRAST_NORMAL
}, baseColors), {}, {
  bg: baseColors.bgLight,
  bgPlaceholder: baseColors.bgPlaceholderLight,
  ctrl: baseColors.ctrlLight,
  ctrlBg: baseColors.ctrlBgLight,
  ctrlDisabled: baseColors.ctrlDisabledLight,
  ctrlDisabledLabel: baseColors.ctrlDisabledLabelLight,
  ctrlHover: baseColors.ctrlHoverLight,
  footerBg: baseColors.footerBgLight,
  keyline: baseColors.keylineLight,
  label: baseColors.labelLight,
  labelCaption: baseColors.labelCaptionLight,
  labelPlaceholder: baseColors.labelPlaceholderLight,
  labelLegal: baseColors.labelLegalLight,
  navBg: baseColors.navBgLight,
  navLabel: baseColors.navLabelLight,
  navLabelDisabled: baseColors.navLabelDisabledLight,
  navLabelHover: baseColors.navLabelHoverLight,
  navLabelSelected: baseColors.navLabelSelectedLight,
  title: baseColors.titleLight,
  badInputBdr: baseColors.badInputBdrLight,
  badInputBg: baseColors.badInputBgLight,
  badInputLabel: baseColors.badInputLabelLight,
  error: baseColors.errorLight,
  errorHover: baseColors.errorHoverLight,
  errorBdr: baseColors.errorBdrLight,
  errorBg: baseColors.errorBgLight,
  info: baseColors.infoLight,
  infoHover: baseColors.infoHoverLight,
  infoBdr: baseColors.infoBdrLight,
  infoBg: baseColors.infoBgLight,
  success: baseColors.successLight,
  successHover: baseColors.successHoverLight,
  successBdr: baseColors.successBdrLight,
  successBg: baseColors.successBgLight,
  warning: baseColors.warningLight,
  warningHover: baseColors.warningHoverLight,
  warningBdr: baseColors.warningBdrLight,
  warningBg: baseColors.warningBgLight,
  clrBlue: baseColors.clrBlueLight,
  clrGreen: baseColors.clrGreenLight,
  clrOrange: baseColors.clrOrangeLight,
  clrPurple: baseColors.clrPurpleLight,
  clrTeal: baseColors.clrTealLight,
  clrGray: baseColors.clrGrayLight,
  clrIndigo: baseColors.clrIndigoLight,
  clrPink: baseColors.clrPinkLight,
  clrRed: baseColors.clrRedLight,
  clrYellow: baseColors.clrYellowLight,
  appleMusicRed: baseColors.appleMusicRedLight
}); // TODO: gradients

export var radii = [3, 4, 6, 15];
radii.small = radii[0];
radii.regular = radii[1];
radii.large = radii[2];
radii.extraLarge = radii[3]; // this must be a singular value (i.e. it can not be 'regular regular', etc.)

var radius = "regular";
export var fontUrl = 'https://www.apple.com/wss/fonts/?families=SF+Pro,v2:100,300,400,500,600,800'; // -apple-system will switch between Text and Display depending on the text size for users on OSX

export var font = '"SF Pro Text", "Helvetica Neue", "HelveticaNeue", "Helvetica", "Arial", sans-serif';
export var fontLarge = '"SF Pro Display", "Helvetica Neue", "HelveticaNeue", "Helvetica", "Arial", sans-serif';
export var fontWeights = [300, 400, 500, 600, 700];
fontWeights.light = fontWeights[0];
fontWeights.regular = fontWeights[1];
fontWeights.medium = fontWeights[2];
fontWeights.semibold = fontWeights[3];
fontWeights.bold = fontWeights[4];
export var TEXT_STYLES = {
  BODY_XS: 'bodyXs',
  BODY_SMALL: 'bodySmall',
  BODY: 'body',
  // TODO: BODY_BP_SM is deprecated and should be removed when 2.0.0 will go live
  BODY_BP_SM: 'bodyBpSm',
  BODY_VIEW_S: 'bodyViewS',
  MENU_LIST_ITEM: 'menuListItem',
  EMAIL_BODY: 'emailBody',
  KPI: 'kpi',
  H6: 'h6',
  H5: 'h5',
  H4: 'h4',
  H3: 'h3',
  H2: 'h2',
  H1: 'h1',
  H1_ELEVATED: 'h1Elevated'
};
export var lineSpacings = (_lineSpacings = {}, _defineProperty(_lineSpacings, TEXT_STYLES.BODY_XS, {
  top: 2,
  bottom: 3
}), _defineProperty(_lineSpacings, TEXT_STYLES.BODY_SMALL, {
  top: 3,
  bottom: 4
}), _defineProperty(_lineSpacings, TEXT_STYLES.BODY, {
  top: 4,
  bottom: 4
}), _defineProperty(_lineSpacings, TEXT_STYLES.BODY_BP_SM, {
  top: 4,
  bottom: 5
}), _defineProperty(_lineSpacings, TEXT_STYLES.BODY_VIEW_S, {
  top: 4,
  bottom: 5
}), _defineProperty(_lineSpacings, TEXT_STYLES.H6, {
  top: 4,
  bottom: 5
}), _defineProperty(_lineSpacings, TEXT_STYLES.H5, {
  top: 4,
  bottom: 5
}), _defineProperty(_lineSpacings, TEXT_STYLES.H4, {
  top: 4,
  bottom: 5
}), _defineProperty(_lineSpacings, TEXT_STYLES.H3, {
  top: 4,
  bottom: 5
}), _defineProperty(_lineSpacings, TEXT_STYLES.H2, {
  top: 6,
  bottom: 6
}), _defineProperty(_lineSpacings, TEXT_STYLES.H1, {
  top: 8,
  bottom: 8
}), _defineProperty(_lineSpacings, TEXT_STYLES.H1_ELEVATED, {
  top: 12,
  bottom: 11
}), _defineProperty(_lineSpacings, TEXT_STYLES.MENU_LIST_ITEM, {
  top: 4,
  bottom: 5
}), _defineProperty(_lineSpacings, TEXT_STYLES.EMAIL_BODY, {
  top: 4,
  bottom: 5
}), _defineProperty(_lineSpacings, TEXT_STYLES.KPI, {
  top: 8,
  bottom: 8
}), _lineSpacings);
export var fontSizes = [11, 12, 13, 14, 15, 16, 17, 18, 20, 24, 34, 41, 64]; // px

fontSizes[TEXT_STYLES.BODY_XS] = fontSizes[0];
fontSizes[TEXT_STYLES.BODY_SMALL] = fontSizes[1]; // regular body size for md and lg viewports

fontSizes[TEXT_STYLES.BODY] = fontSizes[2]; // all heading sizes are not strictly for the html elements matching their name;
// an <h2> would be fontSizes.h2 in a default context, but in different viewports
// or contexts, the <h2> might be h5 size, while still semantically valid.

fontSizes[TEXT_STYLES.H6] = fontSizes[3]; // standard body size for sm viewports
// TODO: BODY_BP_SM is deprecated and should be removed when 2.0.0 will go live

fontSizes[TEXT_STYLES.BODY_BP_SM] = fontSizes[4];
fontSizes[TEXT_STYLES.BODY_VIEW_S] = fontSizes[4];
fontSizes[TEXT_STYLES.H5] = fontSizes[4]; // in for completeness

fontSizes[TEXT_STYLES.EMAIL_BODY] = fontSizes[5]; // stand-alone menu list item

fontSizes[TEXT_STYLES.MENU_LIST_ITEM] = fontSizes[6];
fontSizes[TEXT_STYLES.H4] = fontSizes[7];
fontSizes[TEXT_STYLES.H3] = fontSizes[8];
fontSizes[TEXT_STYLES.H2] = fontSizes[9];
fontSizes[TEXT_STYLES.H1] = fontSizes[10];
fontSizes[TEXT_STYLES.H1_ELEVATED] = fontSizes[12];
fontSizes[TEXT_STYLES.KPI] = fontSizes[11];
export var lineHeights = [13, 16, 18, 19, 20, 22, 24, 25, 30, 41, 45, 68]; // px

lineHeights[TEXT_STYLES.BODY_XS] = lineHeights[0];
lineHeights[TEXT_STYLES.BODY_SMALL] = lineHeights[1];
lineHeights[TEXT_STYLES.BODY] = lineHeights[2];
lineHeights[TEXT_STYLES.H6] = lineHeights[3];
lineHeights[TEXT_STYLES.H5] = lineHeights[4]; // TODO: BODY_BP_SM is deprecated and should be removed when 2.0.0 will go live

lineHeights[TEXT_STYLES.BODY_BP_SM] = lineHeights[4];
lineHeights[TEXT_STYLES.BODY_VIEW_S] = lineHeights[4];
lineHeights[TEXT_STYLES.H4] = lineHeights[5];
lineHeights[TEXT_STYLES.MENU_LIST_ITEM] = lineHeights[5];
lineHeights[TEXT_STYLES.H3] = lineHeights[6];
lineHeights[TEXT_STYLES.EMAIL_BODY] = lineHeights[7];
lineHeights[TEXT_STYLES.H2] = lineHeights[8];
lineHeights[TEXT_STYLES.H1] = lineHeights[9];
lineHeights[TEXT_STYLES.KPI] = lineHeights[10];
lineHeights[TEXT_STYLES.H1_ELEVATED] = lineHeights[11];
export var letterSpacings = [-0.032, -0.025, -0.024, -0.016, -0.011, -0.006, 0, 0.002, 0.006, 0.01, 0.011, 0.015, 0.019]; // em

letterSpacings[TEXT_STYLES.BODY_XS] = letterSpacings[8];
letterSpacings[TEXT_STYLES.BODY_SMALL] = letterSpacings[6];
letterSpacings[TEXT_STYLES.BODY] = letterSpacings[5]; // TODO: BODY_BP_SM is deprecated and should be removed when 2.0.0 will go live

letterSpacings[TEXT_STYLES.BODY_BP_SM] = letterSpacings[3];
letterSpacings[TEXT_STYLES.BODY_VIEW_S] = letterSpacings[3];
letterSpacings[TEXT_STYLES.H5] = letterSpacings[3];
letterSpacings[TEXT_STYLES.H6] = letterSpacings[4];
letterSpacings[TEXT_STYLES.H4] = letterSpacings[1];
letterSpacings[TEXT_STYLES.H3] = letterSpacings[12];
letterSpacings[TEXT_STYLES.H2] = letterSpacings[11];
letterSpacings[TEXT_STYLES.H1] = letterSpacings[10];
letterSpacings[TEXT_STYLES.H1_ELEVATED] = letterSpacings[7];
letterSpacings[TEXT_STYLES.MENU_LIST_ITEM] = letterSpacings[2];
letterSpacings[TEXT_STYLES.EMAIL_BODY] = letterSpacings[0];
letterSpacings[TEXT_STYLES.KPI] = letterSpacings[9];
export var fontForStyle = function fontForStyle(typographyStyleName) {
  switch (typographyStyleName) {
    case TEXT_STYLES.H3:
    case TEXT_STYLES.H2:
    case TEXT_STYLES.H1:
    case TEXT_STYLES.H1_ELEVATED:
    case TEXT_STYLES.KPI:
      return fontLarge;

    default:
      return font;
  }
};
export var HEADING_STYLES = [TEXT_STYLES.H1_ELEVATED, TEXT_STYLES.H1, TEXT_STYLES.H2, TEXT_STYLES.H3, TEXT_STYLES.H4, TEXT_STYLES.H5, TEXT_STYLES.H6, TEXT_STYLES.KPI];
export var pickDefaultTextColor = function pickDefaultTextColor(typographyStyleName) {
  return HEADING_STYLES.includes(typographyStyleName) ? 'title' : 'label';
};
export var makeVariant = function makeVariant(variantName, overridesFn, styles) {
  return styles.reduce(function (acc, styleName) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, "".concat(styleName).concat(variantName), _objectSpread({
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      fontFamily: fontForStyle(styleName),
      fontSize: px(fontSizes[styleName]),
      letterSpacing: em(letterSpacings[styleName]),
      lineHeight: px(lineHeights[styleName]),
      em: {
        fontStyle: 'italic'
      }
    }, overridesFn(styleName))));
  }, {});
}; // the TEXT_STYLES styles that can be medium weight

export var MEDIUM_WEIGHT_TEXT_STYLES = [TEXT_STYLES.H4, TEXT_STYLES.H5, TEXT_STYLES.H6, TEXT_STYLES.BODY, // TODO: BODY_BP_SM is deprecated and should be removed when 2.0.0 will go live
TEXT_STYLES.BODY_BP_SM, TEXT_STYLES.BODY_VIEW_S, TEXT_STYLES.BODY_SMALL];
export var ALL_TEXT_STYLES = Object.values(TEXT_STYLES);
export var TEXT_VARIANTS = {
  REGULAR: 'Regular',
  EMPH: 'Emph',
  MEDIUM: 'Medium'
};
export var EMPH_VARIANTS = ALL_TEXT_STYLES.filter(function (name) {
  return name !== TEXT_STYLES.KPI;
});
export var textStyles = _objectSpread(_objectSpread(_objectSpread({}, makeVariant(TEXT_VARIANTS.REGULAR, function (styleName) {
  return {
    fontWeight: styleName === TEXT_STYLES.EMAIL_BODY ? fontWeights.light : styleName === TEXT_STYLES.KPI ? fontWeights.bold : fontWeights.regular
  };
}, ALL_TEXT_STYLES)), makeVariant(TEXT_VARIANTS.MEDIUM, function () {
  return {
    fontWeight: 500
  };
}, MEDIUM_WEIGHT_TEXT_STYLES)), makeVariant(TEXT_VARIANTS.EMPH, function (styleName) {
  switch (styleName) {
    case TEXT_STYLES.H1:
    case TEXT_STYLES.H2:
    case TEXT_STYLES.H3:
      return {
        fontWeight: fontWeights.bold
      };

    case TEXT_STYLES.EMAIL_BODY:
      return {
        fontWeight: fontWeights.medium
      };

    default:
      return {
        fontWeight: fontWeights.semibold
      };
  }
}, EMPH_VARIANTS)); // force emph styles in <strong> blocks
// TODO: BODY_BP_SM is deprecated and should be removed when 2.0.0 will go live

textStyles.bodyBpSmRegular = _objectSpread(_objectSpread({}, textStyles.bodyBpSmRegular), {}, {
  strong: textStyles.bodyBpSmEmph
});
textStyles.bodyViewSRegular = _objectSpread(_objectSpread({}, textStyles.bodyViewSRegular), {}, {
  strong: textStyles.bodyViewSEmph
}); // force emph styles for bodyRegular

textStyles.bodyRegular = _objectSpread(_objectSpread({}, textStyles.bodyRegular), {}, {
  strong: textStyles.bodyEmph
}); // force emph styles for bodyMedium

textStyles.bodyMedium = _objectSpread(_objectSpread({}, textStyles.bodyMedium), {}, {
  strong: _objectSpread({}, textStyles.bodyEmph)
}); // styled-system already exports a textStyle variant, but this allows us to
// include explicit propTypes

export var textStyle = scaledVariant({
  prop: 'textStyle',
  key: 'textStyles'
});
textStyle.propTypes = {
  textStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
};

var _textStyleVariantsRegex = new RegExp("(\\w+)(".concat(TEXT_VARIANTS.EMPH, "|").concat(TEXT_VARIANTS.MEDIUM, "|").concat(TEXT_VARIANTS.REGULAR, ")"));

export var copyTextStyle = ['bodyViewSRegular', 'bodyRegular'];
/**
 * Utility function for going from a variant name to the text style key
 */

export var styleFromVariant = function styleFromVariant() {
  var variantName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var match = variantName.match(_textStyleVariantsRegex);
  return match ? match[1] : null;
};
export var listMargins = {
  ul: '15px',
  // browser-standard, unrelated to AMP
  ol: '22px' // browser-standard, plus 7px to allow for up to 99 items

};
export var listStyle = variant({
  prop: 'listStyle',
  key: 'listStyles'
});
export var listStyles = {
  none: {},
  ordered: {
    listStyleType: 'decimal',
    marginLeft: listMargins.ol
  },
  unordered: {
    listStyleType: 'disc',
    marginLeft: listMargins.ul
  },
  noBullet: {
    listStyleType: 'none',
    marginLeft: 0
  }
};
listStyle.propTypes = {
  listStyle: PropTypes.oneOfType([PropTypes.oneOf(Object.keys(listStyles)), PropTypes.arrayOf(PropTypes.string)])
};
export var panelColors = {
  standard: {
    iconColor: 'labelPlaceholder',
    backgroundColor: 'bgPlaceholder',
    borderColor: 'keyline',
    borderRadius: 'regular',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  info: {
    iconColor: 'info',
    backgroundColor: 'infoBg',
    borderColor: 'infoBdr',
    borderRadius: 'regular',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  success: {
    iconColor: 'success',
    backgroundColor: 'successBg',
    borderColor: 'successBdr',
    borderRadius: 'regular',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  error: {
    iconColor: 'error',
    backgroundColor: 'errorBg',
    borderColor: 'errorBdr',
    borderRadius: 'regular',
    borderStyle: 'solid',
    borderWidth: '1px'
  },
  warning: {
    iconColor: 'warning',
    backgroundColor: 'warningBg',
    borderColor: 'warningBdr',
    borderRadius: 'regular',
    borderStyle: 'solid',
    borderWidth: '1px'
  }
};
export var cursor = function cursor(_ref) {
  var cursor = _ref.cursor;
  return cursor ? {
    cursor: cursor
  } : {};
};
cursor.propTypes = {
  cursor: PropTypes.string
};
export var objectFit = function objectFit(_ref2) {
  var objectFit = _ref2.objectFit;
  return objectFit ? {
    objectFit: objectFit
  } : {};
};
objectFit.propTypes = {
  objectFit: PropTypes.string
};
export var columnCount = function columnCount(_ref3) {
  var columnCount = _ref3.columnCount;
  return columnCount ? {
    columnCount: columnCount
  } : {};
};
columnCount.propTypes = {
  cursor: PropTypes.number
};
export var hrColor = 'keyline';
export var panelPadding = px(35);
export var borderWidth = px(1);
export var pipedText = function pipedText(props) {
  return {
    display: 'inline',
    margin: 0,
    padding: '0 10px',
    borderLeft: "1px solid ".concat(props.theme.colors.keyline),
    ':first-child': {
      paddingLeft: 0,
      borderLeft: 'none'
    }
  };
};
var bannerPadding = {
  inlineDismissIconTop: px(15),
  dismissIconRight: [px(12), px(15)],
  dismissIconSize: px(8),
  inlineIconTop: px(10),
  inlineIconLeft: [px(12), px(15)],
  inlineIconSize: [px(17), px(20)],
  inlineTop: [13, 14],
  inlineRight: [12, 20],
  inlineDismissableRight: [32, 38],
  inlineBottom: 15,
  inlineLeft: [39, 45],
  pageIconTop: px(15),
  pageIconLeft: [px(12), px(15)],
  pageIconSize: px(25),
  pageTop: 22,
  pageRight: [12, 20],
  pageDismissIconTop: px(25),
  pageDismissableRight: [32, 38],
  pageBottom: [30, 26],
  pageLeft: [47, 50]
};
var button = {
  heightRegular: px(26),
  heightLarge: px(32),
  paddingHorizontal: px(11)
};
var inlineFormLabelOffset = px(8);
var formField = {
  height: [px(40), px(30)],
  textStyle: ['bodyViewSRegular', 'bodyRegular'],
  width: '100%',
  borderColor: 'ctrl',
  boxShadowColor: 'focus',
  paddingHorizontal: px(8),
  borderWidth: px(1),
  selectArrowSize: px(10),
  selectArrowOffset: px(12),
  selectArrowColor: 'labelCaption',
  selectPaddingRight: px(32),
  circleCheckboxSize: px(15),
  circleCheckboxDisabledOpacity: '0.3'
};
var th = {
  paddingY: px(9),
  paddingX: px(10),
  // inferred, not from vspec
  color: 'labelCaption',
  bg: 'bg'
};
var td = {
  paddingY: px(16),
  paddingX: px(10),
  color: 'label',
  bg: 'bg'
};
var tablePlaceholder = {
  padding: px(20),
  minHeight: px(200),
  maxWidth: px(600)
};
var popover = {
  arrowSize: 30,
  arrowColor: 'bg',
  borderColor: 'keyline',
  bgColor: 'bg',
  minWidth: px(200),
  boxShadow: '0 0 15px rgba(0,0,0,.14902), 0 0 1px rgba(0,0,0,.04706)'
};
var tooltip = {
  arrowSize: 16,
  arrowColor: 'footerBg',
  bgColor: 'footerBg',
  minWidth: px(100)
};
var menuList = {
  spacing: 10,
  paddingX: px(20),
  paddingXSelected: px(40),
  textStyle: 'bodyRegular',
  minWidth: px(200),
  hoverBg: 'navBg',
  inlineButtonPaddingX: px(20),
  inlineButtonMarginBottom: px(5),
  inlineButtonWidth: '100%'
};
var topHeader = {
  moreSize: px(20),
  height: px(50),
  color: 'navLabel',
  activeColor: 'navLabelSelected',
  marginX: px(20),
  linkTextStyle: 'h6Regular',
  linkActiveTextStyle: 'h6Emph',
  iconSize: px(20),
  iconSizeNum: 20,
  userTextStyle: 'bodyRegular',
  bg: 'footerBg',
  miniLinksTextStyle: 'menuListItemRegular',
  miniLinksBorderColor: 'keyline',
  miniLinksBorderBottom: '1px solid',
  miniLinksLineHeight: px(50),
  bannerTextStyle: 'h4Emph'
};
var footer = {
  bg: 'footerBg',
  pb: px(30),
  pt: px(26),
  spaceAbove: 'spacer40'
};
var spinner = {
  bg: 'bg',
  inlineBg: 'transparent',
  color: 'labelPlaceholder',
  size: 20,
  inlineSize: 15,
  zIndex: 9,
  opacity: 0.8,
  appearanceSpeed: 300,
  spinnerSpeed: 500
};
var code = {
  bg: 'bgPlaceholder',
  color: 'label',
  fontFamily: '"SF Mono", Menlo, monospace, "SF Pro Icons"',
  lineHeight: '1.3',
  fontWeight: '400',
  letterSpacing: '-0.027em',
  borderColor: 'keyline',
  blockPaddingX: px(16),
  blockPaddingY: px(8),
  blockFontSize: px(15)
};
var tabs = {
  activeUnderline: '2px solid',
  tabMarginRight: px(23),
  textStyle: ['h5Emph', 'h3Regular', 'h4Medium'],
  color: 'ctrl',
  downIconSize: '0.6em',
  rightIconSize: '0.9em',
  spaceBelow: 'spacer20',
  secondary: {
    spaceBelow: 'spacer10',
    textStyle: 'bodyEmph'
  }
};
var tabbedHeader = {
  titleTextStyle: ['h4Emph', 'h3Emph', 'h1Emph'],
  titleMarginRight: px(30),
  spaceBelow: 'spacer20'
};
var modal = {
  edgeSpacing: '10px',
  bg: 'bg',
  zIndex: 10,
  maxWidth: px(700),
  backdrop: {
    bg: 'rgba(0,0,0,.4)'
  },
  content: {
    padding: {
      top: [30, 40],
      bottom: [40]
    }
  },
  body: {
    padding: {
      left: [20, 35],
      right: [20, 35],
      bottom: [40]
    }
  },
  footer: {
    padding: {
      left: [15, 20],
      right: [15, 20],
      top: [15, 14],
      bottom: [15, 14]
    }
  },
  header: {
    padding: {
      left: [20, 35],
      right: [20, 35],
      bottom: [30, 20]
    },
    margin: {
      bottom: [0],
      top: [0]
    },
    textStyle: ['h3Emph', 'h2Emph']
  }
};
var navmenu = {
  paddingTop: px(30),
  itemHeightMobile: px(44),
  itemHeightSide: 30,
  itemHeightPopover: px(40),
  itemSidePaddingTop: 3,
  itemSidePaddingBottom: 3,
  leftOffsetPopover: px(20),
  leftOffsetSide: px(6),
  leftOffset: px(16),
  keylineColor: 'keyline',
  keylineSize: px(1),
  keylineBorder: '1px solid',
  titleTextStyleMobile: 'menuListItemEmph',
  titleTextStyle: 'h5Medium',
  linksMarginBottom: px(25),
  hoverTextWeightNonMobile: 'medium',
  linkActiveBg: 'ctrl',
  linkActiveBgSide: 'footerBg',
  hoverColor: 'ctrlBg',
  hoverColorSide: 'ctrl',
  itemTextStyle: 'bodyRegular',
  itemTextStyleActive: 'bodyMedium',
  itemTextStyleMobile: 'menuListItemRegular',
  color: 'label',
  disabledColor: 'ctrlDisabled',
  bg: 'bg'
};
var sheet = {
  zIndex: 10,
  lightbox: {
    header: {
      borderColor: 'keyline',
      padding: px(16)
    },
    icon: {
      topOffset: px(16),
      leftOffset: px(16),
      width: 20,
      height: 20
    }
  },
  bg: 'bgPlaceholder'
};
var breadcrumbs = {
  offset: px(10),
  arrow: {
    width: px(10),
    height: px(10),
    cursor: 'pointer'
  }
};
var drillIn = {
  offset: {
    sb: ['spacer20']
  },
  header: {
    spacings: {
      sb: 'spacer25',
      mr: px(10)
    }
  },
  buttons: {
    button: {
      offset: {
        right: px(10),
        bottom: px(10)
      }
    },
    spacings: {
      sb: 'spacer30'
    }
  },
  subtitle: {
    spacings: {
      sb: 'spacer20'
    }
  },
  breadcrumbs: {
    spacings: {
      sb: 'spacer20',
      sa: ['spacer30', 'spacer40']
    }
  }
};
var chipsInput = {
  input: {
    margin: px(5),
    minWidth: px(120),
    border: 'none'
  },
  chipsWrapper: {
    padding: px(5),
    borderStyle: 'solid'
  },
  chipWrapper: {
    padding: px(10),
    margin: px(5),
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between'
  },
  closeButton: {
    marginLeft: px(10)
  }
};
var filters = {
  sheet: {
    options: {
      marginTop: px(30),
      width: '100%'
    },
    maxHeight: 'none'
  },
  options: {
    width: px(200)
  },
  maxHeight: px(350)
};
var artworkGrid = {
  item: {
    py: [px(25), px(40)],
    height: [px(110), px(180)],
    borderBottom: '1px solid',
    borderColor: 'keyline'
  },
  title: {
    textStyle: ["h4Emph", "h3Emph"]
  },
  data: {
    ml: px(15),
    pr: px(45)
  },
  status: {
    color: "labelPlaceholder",
    textStyle: "bodySmallRegular"
  },
  artwork: {
    size: [px(60), px(100)]
  }
};
var artwork = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100px',
    width: '100px',
    minWidth: '5px'
  },
  circle: {
    height: '100%',
    width: '100%',
    objectFit: 'cover',
    borderRadius: '50%',
    border: '1px solid',
    borderColor: 'keyline'
  },
  square: {
    height: '100%',
    width: '100%',
    objectFit: 'cover',
    borderRadius: '5%',
    border: '1px solid',
    borderColor: 'keyline'
  },
  rectangle: {
    height: '56px',
    width: '100px',
    objectFit: 'cover',
    borderRadius: '5%',
    border: '1px solid',
    borderColor: 'keyline'
  }
};
var proportional = {
  aspectRatios: {
    "default": 1,
    square: 1,
    wide: 11 / 6,
    narrow: 9 / 16
  },
  artwork: {
    borderRadius: 'regular',
    border: '1px solid',
    borderColor: 'keyline'
  }
};
var boundedGrid = {
  heading: {
    color: "title",
    textStyle: ["h4Medium", "h3Emph"]
  },
  primary: {
    color: "label",
    textStyle: ["h5Regular", "bodyMedium"]
  },
  secondary: {
    color: "labelPlaceholder",
    textStyle: ["h5Regular", "bodyRegular"]
  }
};
var insights = {
  insight: {
    pr: px(20)
  },
  content: {
    ml: [px(24), px(30)],
    pt: [px(30), px(25)],
    pb: [px(34), px(32), px(30)],
    pr: px(10),
    borderBottom: '1px solid',
    borderColor: 'keyline'
  },
  icon: {
    size: px(52),
    mt: [px(30), px(25)]
  },
  date: {
    color: "labelPlaceholder",
    textStyle: "bodyXsEmph",
    mb: px(10)
  },
  title: {
    textStyle: ["h5Regular", "h5Regular", "h4Regular"]
  },
  highlight: {
    textStyle: "h4Emph"
  }
};
var metricHeader = {
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    borderBottom: '1px solid',
    borderColor: 'keyline',
    paddingBottom: '10px'
  },
  flexBox: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'baseline'
  },
  title: {
    display: 'inline',
    textTransform: 'uppercase',
    textStyle: 'bodyEmph',
    sb: 'spacer10'
  },
  total: {
    textStyle: 'kpiRegular',
    multiTextStyle: ['h2Emph', 'h2Emph', 'kpiRegular'],
    sb: 'spacer10'
  },
  delta: {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    textStyle: ['h5Emph', 'bodyMedium', 'bodyMedium'],
    color: 'labelPlaceholder',
    mr: ['16px', '20px', '30px'],
    ml: '11px'
  },
  deltaSubtitle: {
    whiteSpace: 'nowrap',
    textStyle: ['bodyXsEmph', 'bodyMedium', 'bodyMedium'],
    color: 'labelCaption',
    mt: '5px',
    mr: ['16px', '20px', '30px'],
    ml: '11px'
  },
  subtitle: {
    textStyle: ['bodyXsEmph', 'bodyMedium', 'bodyMedium'],
    color: 'labelCaption',
    mr: ['16px', '20px', '30px'],
    mb: '7px'
  },
  divider: {
    width: '1px',
    border: 'none',
    borderLeft: '1px solid',
    borderColor: 'keyline',
    mt: '5px',
    mr: ['16px', '20px', '30px'],
    mb: '10px'
  }
};
var tableSearch = {
  justifyContent: 'center',
  alignItems: 'center',
  smallViewSearch: {
    width: '100%'
  },
  largeViewSearch: {
    width: '250px'
  },
  cancelButton: {
    margin: '0 0 0 10px'
  }
};
var artworkMenuList = {
  menuList: {
    maxHeight: '425px',
    minWidth: '220px'
  },
  item: {
    display: 'flex',
    width: '100%',
    paddingTop: '4px',
    paddingBottom: '4px',
    alignItems: 'center'
  },
  artwork: {
    height: '30px',
    width: '30px',
    marginRight: '10px',
    objectFit: 'cover',
    borderRadius: '50%',
    boxShadow: '1px 1px 1px rgba(0, 0, 0, 0.1)'
  },
  icon: {
    width: '15px',
    height: '15px',
    minWidth: '15px',
    marginRight: '10px'
  },
  title: {
    textStyle: 'bodyRegular',
    color: 'label',
    whiteSpace: 'normal'
  }
};
var sectionHeading = {
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline',
  overflow: 'auto',
  left: {
    margin: ['0 10px 20px 0', '0 20px 20px 0'],
    minWidth: '128px'
  },
  middle: {
    flex: '1 4 auto',
    margin: '15px 0'
  },
  right: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'baseline',
    margin: '20px 0'
  },
  additionalLine: {
    width: '100%',
    margin: '15px 0 14px 0'
  },
  toolPulldown: {
    margin: ['0 5px', '0 10px']
  },
  toolButton: {
    margin: '0 0 0 10px'
  },
  searchButton: {
    margin: ['0 5px', '0 10px']
  }
};
export default {
  space: space,
  breakpoints: breakpoints,
  breadcrumbs: breadcrumbs,
  mediaQueries: mediaQueries,
  responsiveASC: responsiveASC,
  font: font,
  fontWeights: fontWeights,
  fontSizes: fontSizes,
  lineHeights: lineHeights,
  letterSpacings: letterSpacings,
  listMargins: listMargins,
  listStyles: listStyles,
  lineSpacings: lineSpacings,
  textStyles: textStyles,
  copyTextStyle: copyTextStyle,
  colors: colors,
  radii: radii,
  radius: radius,
  hrColor: hrColor,
  panelPadding: panelPadding,
  borderWidth: borderWidth,
  panelColors: panelColors,
  bannerPadding: bannerPadding,
  button: button,
  inlineFormLabelOffset: inlineFormLabelOffset,
  formField: formField,
  th: th,
  td: td,
  tablePlaceholder: tablePlaceholder,
  popover: popover,
  tooltip: tooltip,
  menuList: menuList,
  topHeader: topHeader,
  footer: footer,
  spinner: spinner,
  code: code,
  tabs: tabs,
  tabbedHeader: tabbedHeader,
  modal: modal,
  navmenu: navmenu,
  sheet: sheet,
  drillIn: drillIn,
  chipsInput: chipsInput,
  filters: filters,
  artworkGrid: artworkGrid,
  artwork: artwork,
  insights: insights,
  proportional: proportional,
  boundedGrid: boundedGrid,
  metricHeader: metricHeader,
  tableSearch: tableSearch,
  artworkMenuList: artworkMenuList,
  sectionHeading: sectionHeading
};